import { InjectionKey, Ref } from 'vue';

/** What a V2CanvasPage offers its descendants (plan §5.2). */
export interface ICanvasPage {
  /** The page's width (the scroller's `offsetWidth`: no scrollbar flips, the keyboard never changes it). */
  width: Readonly<Ref<number>>;
  /** The sticky head's height. */
  headHeight: Readonly<Ref<number>>;
  /** The scroller's visible height. */
  viewHeight: Readonly<Ref<number>>;
  /** The page root: the only scroller. */
  scroller: Readonly<Ref<HTMLElement | null>>;
  /**
   * Scrolls instantly so `element` sits `extra` px under the sticky head
   * (smooth scrolling would cross, and mount, every placeholder).
   */
  scrollToElement(element: HTMLElement, extra?: number): void;
}

export const CANVAS_PAGE_KEY: InjectionKey<ICanvasPage> = Symbol('canvas-page');

export interface ICanvasPageSize {
  width: number;
  viewHeight: number;
  headHeight: number;
}

/** What a V2CanvasPage exposes to the page that renders it (a template ref). */
export interface ICanvasPageHandle {
  scroller: HTMLElement | null;
  scrollToElement(element: HTMLElement, extra?: number): void;
}
